<template>
  <content-dialog
    :visible.sync="modalVisible"
    scrollable
    max-width="500"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Approve Deal
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-6">
      <p>Are you sure you want to approve this deal? No changes can be made afterwards.</p>
    </v-card-text>

    <template slot="dialogActions">
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        @click="updateYacht"
      >
        <v-icon
          small
          left
        >
          check
        </v-icon>
        Yes, approve
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import Yacht from '@/models/Yacht'
import ContentDialog from '@/components/helpers/Dialog'

export default {
    name: 'ApproveDealDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        reason: null,
        submitting: false
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      yachtDirty: {
        get: function () {
          return this.yacht
        },
        set: function (value) {
          this.$emit('update:yacht', value)
        }
      }
    },
    methods: {
      async updateYacht() {
        this.submitting = true

        try {
          let response = await Yacht.api.approveDeal(this.yachtDirty.id)

          this.yachtDirty = response.yacht
          this.modalVisible = false
          this.$store.dispatch('alert', {
            'text': 'Sales started for selected yacht owner.',
            'color': 'success'
          })
        } catch (e) {
          this.$store.dispatch('alert', {
            'text': 'Something went wrong',
            'color': 'error'
          })
          throw e
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>

<style scoped>
</style>
